var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data && _vm.data.length >= 8)?_c('Cube',{attrs:{"dataMagic":_vm.data,"type":_vm.type,"autoplay":_vm.autoplay},on:{"clickItem":_vm.clickItem}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }